import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/views/Auth.vue'
import Photos from '@/views/Photos.vue'
import Infos from '@/views/Infos.vue'
import Confirm from '@/views/Confirm.vue'
import End from '@/views/End.vue'
import Pilot from '@/views/Pilot.vue'

import store from '@/store'

import config from '../vue.config.js'

Vue.use(Router)

const router = new Router({
  base: config.publicPath,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [{
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta: {
      requiresGuest: true,
    }
  }, {
    path: '/',
    name: 'photos',
    component: Photos,
    meta: {
      title: 'J\'ajoute <br /> mes photos',
      prev: null,
      next: 'infos',
      datas: ['counterPicture', 'registrationPicture'],
      requiresAuth: true,
    }
  }, {
    path: '/infos',
    name: 'infos',
    component: Infos,
    meta: {
      title: 'Je saisis <br /> mes informations',
      prev: 'photos',
      next: 'confirm',
      datas: ['kilometers', 'comment', 'counterInMiles'],
      requiresAuth: true,
    }
  }, {
    path: '/confirm',
    name: 'confirm',
    component: Confirm,
    meta: {
      title: 'Je confirme <br /> mon relevé',
      prev: 'infos',
      next: null,
      datas: ['counterPicture', 'registrationPicture', 'kilometers', 'comment', 'confirm', 'counterInMiles'],
      requiresAuth: true,
    }
  }, {
    path: '/end',
    name: 'end',
    component: End,
    meta: {
      title: 'Déclaration de <br /> relevé envoyée',
      requiresAuth: true,
    }
  }, {
    path: '/pilot',
    name: 'pilot',
    component: Pilot,
    meta: {
      title: 'Lorem ipsum dolor sit amet',
      requiresAuth: true,
    }
  }]
})

router.beforeEach((to, from, next) => {
  // Check if local datas expired
  if( store.getters.isDead ) {
    // Reset app
    store.dispatch('resetDatas')
    store.dispatch('logout')
  } else {
    // Update last sign of life
    store.dispatch('breathe')
  }

  // Check user authorization
  if( to.meta.requiresAuth && !store.getters.isAuthenticated ) {
    // Redirect guest users to auth
    next({name: 'auth'})
  } else if( from.name === 'auth' && to.name === 'photos' && store.getters.isPilot ) {
      // Redirect user to specific page if pilot is true
      next({name: 'pilot'})
  } else if( to.name === 'photos' && store.getters.isPilot ) {
      // Redirect user to specific page if pilot is true
      next({name: 'pilot'})
  } else if( to.meta.requiresGuest && !store.getters.isGuest ) {
    // Redirect loggedin user to home
    next({name: 'photos'})
  } else if( !store.getters.isStepValid(to.meta.prev) ) {
    // If previous (!== from) step is invalid redirect to this step (!== from)
    next({name: to.meta.prev})
  } else {
    next()
  }
})

export default router
